<header class="container-style-primary container grid">
  <a class="logo-wrapper grid-item-0" [routerLink]="'/'">
    <img [src]="cdnBase + '/logo-1.png'" alt="logo" class="logo-img" />
    <img [src]="cdnBase + '/logo-3.png'" alt="logo-text" class="logo-text" />
  </a>
  <div class="button-with-games-dropdown">
    <a class="home-button button black medium" [routerLink]="'/'" (mouseenter)="onHomeMouseEnter()" (mouseleave)="onHomeMouseLeave()">
      <app-icon [icon]="'home'" [hasHoverState]="true" [isHovered]="isHomeHovered"></app-icon>
    </a>
    <app-top-bar-games></app-top-bar-games>
  </div>
  <div class="grid-item-1 wallet wallet-background" [toggleDropdown]="walletDropdown" [class.active]="!walletDropdown.collapsed">
    <div class="wallet-overlay">
      <span class="balance-value">
        <app-icon [width]="16" [icon]="'coin'"></app-icon>
        <app-currency [value]="session.currentBalance()" [animation]="true" [size]="16" [allowNegative]="false"></app-currency>
      </span>

      <span class="button red small wallet-button">
        <app-icon [width]="20" [icon]="'wallet'" pathStroke="#ffffff"></app-icon>
        wallet
      </span>
    </div>
    <app-dropdown #walletDropdown [width]="220" class="wallet-dropdown">
      @for (type of balanceTypes; track type) {
      <app-dropdown-item [active]="session.balanceType() === type" (click)="selectBalanceType(type)">
        <button class="dropdown-balance-type">
          <span>{{ balanceLabels[type] }}</span>
          <app-currency [value]="session.balances()[type]" [size]="14" [allowNegative]="false"></app-currency>
        </button>
      </app-dropdown-item>
      }
      <app-dropdown-item class="red" (click)="uiService.openStoreModal()">
        <button class="dropdown-deposit-button">
          <app-icon [width]="16" [icon]="'wallet'" pathFill="#CE372E" pathStroke="#00000087"></app-icon>
          Deposit
        </button>
      </app-dropdown-item>
      <app-dropdown-item (click)="uiService.openStoreModal('withdraw')">
        <button>
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.7939 3.13525V8.44564C11.7939 8.60553 11.6644 8.73477 11.5048 8.73477H11.0191C10.7438 8.73477 10.5197 8.95884 10.5197 9.23438V9.84733C10.5197 10.0072 10.3902 10.1365 10.2306 10.1365H5.77026C5.61066 10.1365 5.48113 10.0072 5.48113 9.84733V9.2419C5.48113 8.96665 5.25706 8.74258 4.98181 8.74258H4.49579C4.33619 8.74258 4.20666 8.61334 4.20666 8.45345V3.13525H3.38294H2.80469V11.2571C2.80469 11.417 2.93422 11.5462 3.09381 11.5462H12.9068C13.0664 11.5462 13.1959 11.417 13.1959 11.2571V3.13525H12.6176H11.7939Z"
              fill="#CE372E"
            />
            <path
              d="M9.94173 9.5582V9.23438C9.94173 8.63994 10.4251 8.15652 11.0193 8.15652H11.2159V3.13525H4.78516V8.16461H4.98205C5.57621 8.16461 6.05963 8.64803 6.05963 9.24219V9.55849H9.94173V9.5582Z"
              fill="#CE372E"
            />
            <path
              d="M14.8437 0.454346H1.15846C0.520646 0.454346 0.00195312 0.973039 0.00195312 1.61085V4.08144C0.00195312 4.71925 0.520646 5.23795 1.15846 5.23795H2.22736V4.65969V3.13542H1.69305C1.53346 3.13542 1.40393 3.00618 1.40393 2.84629C1.40393 2.6864 1.53346 2.55716 1.69305 2.55716H14.3094C14.469 2.55716 14.5985 2.6864 14.5985 2.84629C14.5985 3.00618 14.469 3.13542 14.3094 3.13542H13.7751V4.65969V5.23795H14.844C15.4818 5.23795 16.0005 4.71925 16.0005 4.08144V1.61085C16.0002 0.973039 15.4815 0.454346 14.8437 0.454346Z"
              fill="#CE372E"
            />
          </svg>
          Withdraw
        </button>
      </app-dropdown-item>
      <app-dropdown-item [routerLink]="'/rewards'">
        <a>
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0,0,256,256">
            <g
              fill="#000000"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <g transform="scale(5.12,5.12)">
                <path
                  d="M17,0c-0.55078,0 -1,0.44922 -1,1v8c0,0.55078 0.44922,1 1,1h16c0.55469,0 1,-0.44922 1,-1v-8c0,-0.55078 -0.44531,-1 -1,-1zM8,2c-1.65234,0 -3,1.34766 -3,3v42c0,1.65234 1.34766,3 3,3h34c1.65234,0 3,-1.34766 3,-3v-42c0,-1.65234 -1.34766,-3 -3,-3h-6v4h5v40h-32v-40h5v-4zM11,8v36h28v-36h-3v1c0,1.65234 -1.34766,3 -3,3h-16c-1.65234,0 -3,-1.34766 -3,-3v-1zM15,17h8v8h-8zM17,19v4h4v-4zM26,20h9v2h-9zM15,30h8v8h-8zM17,32v4h4v-4zM18,33h2v2h-2zM26,33h9v2h-9z"
                  fill="#CE372E"
                ></path>
              </g>
            </g>
          </svg>
          Free Coins
        </a>
      </app-dropdown-item>
    </app-dropdown>
  </div>
  @if (session.profile()) {
  <button (click)="handleOpenUserMenu()" class="grid-item-2 user">
    <img class="user-avatar" [src]="session.profile().avatar" [alt]="session.profile().name" />
    <span class="user-username">{{ session.profile().name }}</span>
    <app-level-new class="user-level badge badge_rounded badge_font-l" [level]="session.profile().level"></app-level-new>
    <span class="user-arrow" [class.rotate]="!dropdown.isCollapsed()">
      <app-icon icon="arrow" />
    </span>
    <app-dropdown #dropdown [width]="200" [maxHeight]="500" class="profile-dropdown">
      <app-dropdown-item routerLink="profile">
        <svg class="icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 0C4.25534 0 2.83594 1.4194 2.83594 3.16406C2.83594 4.90873 4.25534 6.32812 6 6.32812C7.74466 6.32812 9.16406 4.90873 9.16406 3.16406C9.16406 1.4194 7.74466 0 6 0Z"
            fill="#CE372E"
          />
          <path
            d="M9.9367 8.3952C9.07045 7.51563 7.92209 7.03125 6.70312 7.03125H5.29688C4.07794 7.03125 2.92955 7.51563 2.0633 8.3952C1.20129 9.27045 0.726562 10.4258 0.726562 11.6484C0.726562 11.8426 0.883969 12 1.07812 12H10.9219C11.116 12 11.2734 11.8426 11.2734 11.6484C11.2734 10.4258 10.7987 9.27045 9.9367 8.3952Z"
            fill="#CE372E"
          />
        </svg>
        Profile
      </app-dropdown-item>
      <app-dropdown-item [routerLink]="'/profile/history'">
        <app-icon [width]="16" [icon]="'game_history'" [hasHoverState]="true" [pathStroke]="'#CE372E'"></app-icon>
        Game History
      </app-dropdown-item>
      <app-dropdown-item [routerLink]="'/profile/transactions'">
        <app-icon [width]="16" [icon]="'transaction_history'" [hasHoverState]="true" [pathStroke]="'#CE372E'"></app-icon>
        Transactions History
      </app-dropdown-item>
      <app-dropdown-item [routerLink]="'/rewards'" class="red">
        <app-icon [icon]="'rewards'" [width]="16" [pathStroke]="'#CE372E'"></app-icon>
        Rewards
      </app-dropdown-item>
      <app-dropdown-item [routerLink]="'/affiliates'">
        <app-icon [width]="16" [icon]="'affiliates'" [hasHoverState]="true" [pathStroke]="'#CE372E'"></app-icon>
        Affiliates
      </app-dropdown-item>
      <!--      <app-dropdown-item (click)="openPromotionModal()">-->
      <!--        <app-icon [width]="16" [icon]="'promotion'" [hasHoverState]="true" [pathStroke]="'#CE372E'"></app-icon>-->
      <!--        Website Promotion-->
      <!--      </app-dropdown-item>-->
      <app-dropdown-item [routerLink]="'/tos'">
        <app-icon [width]="16" [icon]="'tos'" [hasHoverState]="true" [pathStroke]="'#CE372E'"></app-icon>
        TOS
      </app-dropdown-item>
      <app-dropdown-item [routerLink]="'/faq'">
        <app-icon [width]="16" [icon]="'faq'" [hasHoverState]="true" [pathStroke]="'#CE372E'" [pathFill]="'#CE372E'"></app-icon>
        FAQ
      </app-dropdown-item>
      @if (session.is_admin) {
      <app-dropdown-item routerLink="admin" routerLinkActive="admin">
        <svg class="icon" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.7944 3.13525V8.44564C11.7944 8.60553 11.6648 8.73477 11.5052 8.73477H11.0195C10.7443 8.73477 10.5202 8.95884 10.5202 9.23438V9.84733C10.5202 10.0072 10.3907 10.1365 10.2311 10.1365H5.7707C5.6111 10.1365 5.48157 10.0072 5.48157 9.84733V9.2419C5.48157 8.96665 5.2575 8.74258 4.98225 8.74258H4.49623C4.33663 8.74258 4.2071 8.61334 4.2071 8.45345V3.13525H3.38338H2.80513V11.2571C2.80513 11.417 2.93465 11.5462 3.09425 11.5462H12.9072C13.0668 11.5462 13.1963 11.417 13.1963 11.2571V3.13525H12.6181H11.7944Z"
            fill="#CE372E"
          />
          <path
            d="M9.94267 9.5582V9.23438C9.94267 8.63994 10.4261 8.15652 11.0202 8.15652H11.2168V3.13525H4.78609V8.16461H4.98299C5.57714 8.16461 6.06056 8.64803 6.06056 9.24219V9.55849H9.94267V9.5582Z"
            fill="#CE372E"
          />
          <path
            d="M14.8437 0.454346H1.15846C0.520646 0.454346 0.00195312 0.973039 0.00195312 1.61085V4.08144C0.00195312 4.71925 0.520646 5.23795 1.15846 5.23795H2.22736V4.65969V3.13542H1.69305C1.53346 3.13542 1.40393 3.00618 1.40393 2.84629C1.40393 2.6864 1.53346 2.55716 1.69305 2.55716H14.3094C14.469 2.55716 14.5985 2.6864 14.5985 2.84629C14.5985 3.00618 14.469 3.13542 14.3094 3.13542H13.7751V4.65969V5.23795H14.844C15.4818 5.23795 16.0005 4.71925 16.0005 4.08144V1.61085C16.0002 0.973039 15.4815 0.454346 14.8437 0.454346Z"
            fill="#CE372E"
          />
        </svg>
        Admin Panel
      </app-dropdown-item>
      }
      <app-dropdown-item (click)="session.logout()">
        <svg class="icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.33268 3.86675C5.33268 2.74664 5.33268 2.18659 5.55067 1.75877C5.74242 1.38244 6.04838 1.07648 6.4247 0.884735C6.85255 0.666748 7.41255 0.666748 8.53268 0.666748H10.1327C11.2528 0.666748 11.8128 0.666748 12.2407 0.884735C12.617 1.07648 12.9229 1.38244 13.1147 1.75877C13.3327 2.18659 13.3327 2.74664 13.3327 3.86675V10.1334C13.3327 11.2535 13.3327 11.8135 13.1147 12.2414C12.9229 12.6177 12.617 12.9237 12.2407 13.1154C11.8128 13.3334 11.2528 13.3334 10.1327 13.3334H8.53268C7.41255 13.3334 6.85255 13.3334 6.4247 13.1154C6.04838 12.9237 5.74242 12.6177 5.55067 12.2414C5.33268 11.8135 5.33268 11.2535 5.33268 10.1334V9.16675H7.99935C9.19595 9.16675 10.166 8.19668 10.166 7.00008C10.166 5.80348 9.19595 4.83342 7.99935 4.83342H5.33268V3.86675ZM3.5886 5.58933C3.91404 5.2639 3.91404 4.73626 3.5886 4.41083C3.26317 4.08539 2.73553 4.08539 2.4101 4.41083L0.410094 6.41082C0.0846563 6.73628 0.0846563 7.26388 0.410094 7.58935L2.4101 9.58935C2.73553 9.91475 3.26317 9.91475 3.5886 9.58935C3.91404 9.26388 3.91404 8.73628 3.5886 8.41082L3.0112 7.83342H7.99935C8.45962 7.83342 8.83268 7.46035 8.83268 7.00008C8.83268 6.53981 8.45962 6.16675 7.99935 6.16675H3.0112L3.5886 5.58933Z"
            fill="#CE372E"
          />
        </svg>
        Log out
      </app-dropdown-item>
    </app-dropdown>
  </button>
  } @if(!session.profile()){
  <button class="grid-item-2 button red medium login" (click)="session.openLoginModal()">login</button>
  }
</header>
<app-top-bar-navigation></app-top-bar-navigation>
